//TODO: Statsig po_request_1st_payout_method_on_finance_workspace. Remove after experiment finish
export const REQUEST_FIRST_PAYOUT_METHOD_EXPERIMENT_NAME =
    'po_request_1st_payout_method_on_finance_workspace';
export const REQUEST_FIRST_PAYOUT_METHOD_PARAMETER_NAME = 'requestBankAccount';
export const FIRST_PAYOUT_METHOD_EXPERIMENT_CONTROL = 'CONTROL';
export const FIRST_PAYOUT_METHOD_EXPERIMENT_MANDATORY = 'MANDATORY';
export const FIRST_PAYOUT_METHOD_EXPERIMENT_SKIPPABLE = 'SKIPPABLE';

export const PAYOUT_METHOD_EVENT_NAMES = {
    ADD_NEW_PAYOUT_METHOD:
        'OLPS - Finance Workspace - Add Payout Info - Payout Info Form',
};
